import { ActionIcon, Tooltip } from '@mantine/core'

import IconClock from 'src/icons/IconClock'

interface TrackerIconButtonProps {
  trackerId: string
  onClick: (trackerId: string) => void
}

const TrackerIconButton = ({ trackerId, onClick }: TrackerIconButtonProps) => {
  return (
    <Tooltip label="View tracker" withArrow position="top" className="text-xs">
      <ActionIcon
        variant="subtle"
        className="h-5 w-5 transition-transform hover:scale-110"
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          onClick(trackerId)
        }}
      >
        <IconClock className="h-4 w-4 fill-none stroke-doubleNickel-gray-500" />
      </ActionIcon>
    </Tooltip>
  )
}

export default TrackerIconButton
